<div class="col-12">
    <div class="card" style="height:100%;">
      <div class="card-header card-header-grey">
        <h4 class="card-title">
          Job Alertes
        </h4>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col-4">
          <input matTooltip="Vous ne pouvez créer qu'un maximum de 3 job alertes"
               matTooltipPosition="above"
               matTooltipClass="example-tooltip-red"
               type="button"
               (click)="openDialogAdd()"
               [disabled]="rows.length >= 3"
               class="btn btn-next btn-fill btn-rose btn-wd"
               value="Créer une job alerte">
        </div>
      </div>
      <br/>
      <br/>
      <div class="row">
        <div class="col-12 text-center" *ngIf="rows.length === 0">Aucune JobAlerte trouvée.</div>
      </div>
      <div class="row justify-content-between" style="align-content: center">
          <mat-card *ngFor="let jobal of rows" class="col-md-3" style="margin-right:2rem;">
            <mat-card-header>
              <mat-card-title style="color: #000000">{{jobal.jobalert_nom}}</mat-card-title>
              <mat-card-subtitle>{{jobal.jobalert_mail}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <strong>Fonctions :</strong>
              <br/>
              <p [innerHTML]="jobal.jobalert_fonction | replaceLineBreaks">
              </p>
              <strong>Régions :</strong>
              <br/>
              <p [innerHTML]="jobal.jobalert_region | replaceLineBreaks">
              </p>
            </mat-card-content>
            <mat-card-actions class="text-center">
              <input type="button"
                     (click)="editRecord(jobal)"
                     class="btn btn-next btn-fill btn-rose btn-wd"
                     value="MODIFIER"
                     style="margin-right:1rem;">
              <input type="button"
                     (click)="onDelete(jobal.idcandidat_jobalert)"
                     class="btn btn-next btn-fill btn-rose btn-wd"
                     value="SUPPRIMER">
            </mat-card-actions>
          </mat-card>
      </div>
      <br/>
    </div>
</div>

